<template>
  <b-navbar class="p-0" toggleable="lg" type="light" fixed="top" id="nav" style="    max-width: 1400px; margin:auto">
    <b-navbar-brand
      class="font-family-headings"
      to="/"
      style="margin:0px; margin-right:-25px; padding:0px; width:210px"
    >
      <b-img
        src="@/assets/images/logocta.png"
        alt
        class="img-fluid"
        style="width:100%; max-width:260px"
      />
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="mx-auto">
        <!-- <b-nav-item exact-active-class="active" v-scroll-to="{ el: '#noticias', offset: -150 }">Noticias</b-nav-item> -->
        <b-nav-item to="/noticias/" style="color:blue">Noticias</b-nav-item>
        <b-nav-item v-scroll-to="{ el: '#nosotros', offset: -150 }" exact-active-class="active">Nosotros</b-nav-item>
        <b-nav-item v-scroll-to="{ el: '#calendario', offset: -150 }" exact-active-class="active">Calendario</b-nav-item>
        <b-nav-item v-scroll-to="{ el: '#ranking', offset: -150 }" active-class="active">Ranking</b-nav-item>
        <b-nav-item href="https://ticxelagency.com/cta/magazine.pdf">Revista</b-nav-item>
        <b-nav-item
          href="/login"
          active-class="active"
          class="d-lg-none"
          style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:16px"
        >Ingresa</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    <b-navbar-brand
      class="font-family-headings d-none d-lg-block"
      to="/"
      style="margin:0px; padding:0px; margin-right:30px"
    >
      <b-button
            to="/login"
            variant="secondary"
            shadow-sm
            style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
            class="shadow"
          >Ingresa</b-button>
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {};
  },
  props: {
    isLight: {
      type: Boolean,
      required: false
    }, 
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", function() {
        var navbar = document.getElementById("nav");
        var nav_classes = navbar.classList;
        let items = document.querySelectorAll(".nav-link");
        if (document.documentElement.scrollTop >= 150) {
 
          items.forEach(element => {
            element.style.color = "#333";
          });
          if (nav_classes.contains("shrink") === false) {
            nav_classes.toggle("shrink");
          }
          if (nav_classes.contains("shadow") === false) {
            nav_classes.toggle("shadow");
          }
        } else {
          items.forEach(element => {
            element.style.color = this.isLight ? "#000" :"#fff" ;
          });
          if (nav_classes.contains("shrink") === true) {
            nav_classes.toggle("shrink");
          }
          if (nav_classes.contains("shadow") === true) {
            nav_classes.toggle("shadow");
          }
        }
      });
    });
  }
};
</script>

<style>
nav.shrink {
  padding: 0.3rem;
  background: #f4f4f4;
  height: 100px;
}
@media only screen and (max-width: 991px) {
  #nav-collapse {
  background: gray;
}

}

</style>